import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';

const SelectOption = (props) => {
  const { data } = props;

  return (
    <components.Option {...props}>
      <div className="flex items-center gap-2">
        {data.icon && <span className="text-gray-400">{data.icon}</span>}
        <span>{data.label}</span>
      </div>
    </components.Option>
  );
};

SelectOption.propTypes = {
  data: PropTypes.object.isRequired,
};

export default SelectOption;
